import cardVideo from '../assest/video.mp4';
import noSaintImage from '../assest/image.jpg';
import pixlImage from '../assest/pixl.jpg';
import pabloImage from '../assest/pablo.jpg';

const cards = [
  {
    id: 'food',
    title: 'Food, Drinks & Accessories',
    subtitle: 'Cadbury, Monster, Pringles, Raw & more',
    badge: '',
    tone: 'food',
    video: cardVideo,
  },
  {
    id: 'nosaint',
    title: 'NO SAINT',
    subtitle: 'Device and Pods',
    badge: 'DEVICE AND PODS',
    tone: 'saint',
    image: noSaintImage,
  },
  {
    id: 'pixl',
    title: 'PIXL',
    subtitle: 'Kits, Pods & Nic Salts',
    badge: '',
    tone: 'pixl',
    image: pixlImage,
  },
  {
    id: 'pablo',
    title: 'PABLO',
    subtitle: 'Nicotine Pouches',
    badge: 'NICOTINE POUCHES',
    tone: 'pablo',
    image: pabloImage,
  },
];

function CategoryShowcase() {
  return (
    <section className="category-showcase" aria-label="Featured categories">
      {cards.map((card) => (
        <article key={card.id} className="category-card">
          <div
            className={`category-card__visual category-card__visual--${card.tone} ${
              card.video ? 'category-card__visual--video' : ''
            } ${card.image ? 'category-card__visual--image' : ''}`}
          >
            {card.video && (
              <video className="category-card__video" autoPlay loop muted playsInline>
                <source src={card.video} type="video/mp4" />
              </video>
            )}
            {card.image && <img className="category-card__image" src={card.image} alt={card.title} />}
            {card.badge && (
              <div className="category-card__badge">
                <span>{card.badge}</span>
              </div>
            )}
          </div>
          <h3>{card.title}</h3>
          <p>{card.subtitle}</p>
        </article>
      ))}
    </section>
  );
}

export default CategoryShowcase;
